<template>
  <div class="root-container">
    <slot />
  </div>
</template>
<script>
export default {
  name: "RootContainer",
  props: {},
  methods: {}
};
</script>
<style lang='scss'>
.root-container {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>